import { render } from "./BaseInput.vue?vue&type=template&id=612827a1&scoped=true"
import script from "./BaseInput.vue?vue&type=script&lang=js"
export * from "./BaseInput.vue?vue&type=script&lang=js"

import "./BaseInput.vue?vue&type=style&index=0&id=612827a1&scoped=true&lang=css"

import exportComponent from "C:\\www\\mutual-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612827a1"]])

export default __exports__